<template>
    <svg style="transform: scale(0.8)" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
        <title>编组 23</title>
        <desc>Created with Sketch.</desc>
        <defs>
            <linearGradient x1="98.0447474%" y1="11.7238668%" x2="-14.6011466%" y2="118.722414%" id="linearGradient-1">
                <stop stop-color="#32C5FF" offset="0%"></stop>
                <stop stop-color="#1442AA" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="发票信息-有默认" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="首页1" transform="translate(-1433.000000, -452.000000)" fill-rule="nonzero">
                <g id="编组-23" transform="translate(1433.000000, 452.000000)">
                    <path d="M1.84206454,5.77315973e-14 C0.825375692,0.000852479899 0.00127957027,0.824602488 0,1.84129089 L0,12.1540672 C0.00127874477,13.1708812 0.825250533,13.994853 1.84206454,13.9961317 L12.1571618,13.9961317 C13.1742779,13.9952793 13.9987204,13.1711829 14,12.1540672 L14,1.84129089 C13.9987198,0.824300667 13.1741527,0.000425963424 12.1571618,5.77315973e-14 L1.84206454,5.77315973e-14 Z" id="Shape" fill="url(#linearGradient-1)"></path>
                    <g id="对号" transform="translate(3.000000, 4.000000)" fill="#FFFFFF" stroke="#FFFFFF" stroke-width="0.5">
                        <path d="M2.86793115,5.2547995 L7.93803351,0.348448708 C8.02262677,0.26734352 8.02042954,0.136959218 7.93254044,0.0579073196 C7.84574996,-0.0211445792 7.70622601,-0.0190912792 7.62163275,0.0630405588 L2.68556127,4.84003371 L0.375176597,2.68099296 C0.289484721,2.60091441 0.149960783,2.60091441 0.064268907,2.68099296 L0.064268907,2.68099296 C-0.021422969,2.76107151 -0.021422969,2.8914558 0.064268907,2.97153435 L2.52736089,5.27327917 C2.60536247,5.34617118 2.72620997,5.35233107 2.81190185,5.29381212 C2.83277551,5.28354565 2.85145195,5.27122587 2.86793115,5.2547995 Z" id="路径"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "CustomChecked"
    }
</script>

<style scoped>

</style>
